export const siteInfo = {
  name: "直曝",
  fullName: "直曝 · 网络爆料投稿平台",
  slogan: "有料，就放心投",
  intro:
    "直曝是一个专注匿名线索收集与内容核查的投稿平台。我们不做流量标题，不追热点起哄，只做一件事：让普通人手上的真实材料，安全地抵达编辑的桌面。",
  email: "tips@zhibao-editor.com",
  editorEmail: "editor@zhibao-editor.com",
  workTime: "线索接收：全年无休；编辑回复：工作日 10:00 - 19:00",
  since: "2021",
};

export const navLinks = [
  { label: "首页", href: "/" },
  { label: "爆料线索库", href: "/leads" },
  { label: "我要投稿", href: "/submit" },
  { label: "常见问题", href: "/faq" },
  { label: "关于我们", href: "/about" },
  { label: "联系我们", href: "/contact" },
];

export const submitChannels = [
  {
    icon: "ri-edit-box-line",
    title: "在线投稿表单",
    desc: "填写线索标题、类别与内容即可提交，无需注册，联系方式可留空。",
    action: "打开投稿通道",
    href: "/submit",
  },
  {
    icon: "ri-chat-private-line",
    title: "匿名后台私信",
    desc: "在站内后台直接发消息给编辑，会话不保留手机号与设备号。",
    action: "进入后台私信",
    href: "/submit",
  },
  {
    icon: "ri-mail-send-line",
    title: "加密邮箱直达",
    desc: "把材料整理成压缩包发送至编辑邮箱，标题注明线索类别即可。",
    action: "查看邮箱地址",
    href: "/contact",
  },
];

export const siteStats = [
  { value: "38,600+", label: "累计收到线索" },
  { value: "2,140", label: "完成核查选题" },
  { value: "97%", label: "投稿人身份零泄露" },
  { value: "全年无休", label: "线索接收时间" },
];

export const submitSteps = [
  {
    step: "01",
    title: "写下你知道的事",
    desc: "不用讲究文笔，把时间、地点、人物、经过说清楚就够了。一句话也能投。",
  },
  {
    step: "02",
    title: "选择线索类别",
    desc: "从消费维权、职场内幕、行业观察等类别中选一个，方便编辑快速分流。",
  },
  {
    step: "03",
    title: "编辑初步核查",
    desc: "编辑会在 3 个工作日内给出初步反馈，需要补充材料时会通过你留下的方式联系。",
  },
  {
    step: "04",
    title: "匿名化处理与发布",
    desc: "所有可识别信息在发布前统一打码，投稿人姓名从不出现在报道中。",
  },
];

export const principles = [
  {
    icon: "ri-shield-keyhole-line",
    title: "身份优先保护",
    desc: "投稿记录与内容库分离存储，只有两名值班编辑可以查看原始材料。",
  },
  {
    icon: "ri-file-search-line",
    title: "先核实再发布",
    desc: "任何一条线索都要经过至少两次交叉验证，单方陈述不会被直接登出。",
  },
  {
    icon: "ri-emotion-normal-line",
    title: "不煽动不站队",
    desc: "我们陈述事实、标注来源，把判断留给读者，避免情绪化的表达。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续跟进与更正",
    desc: "发布不等于结束。有新证据就更新，发现错误就更正，并公开说明。",
  },
];

export const testimonials = [
  {
    quote:
      "我以为匿名投稿就是发出去石沉大海，没想到第三天就收到了编辑的回复，还帮我把材料里的时间线理了一遍。",
    name: "一位投稿人",
    role: "消费维权线索",
  },
  {
    quote:
      "整个过程没有问我要身份证，也没有让我露脸。材料发过去之后，我最担心的那部分信息被处理得干干净净。",
    name: "热心读者",
    role: "民生线索",
  },
  {
    quote:
      "作为从业者，我最看重的是他们先核实再发布的习惯。有一处数据他们来回问了我三次，最后没核实清楚的部分直接没写。",
    name: "匿名投稿人",
    role: "行业观察线索",
  },
];

export const footerLinks = [
  {
    title: "投稿通道",
    links: [
      { label: "在线投稿表单", href: "/submit" },
      { label: "匿名后台私信", href: "/submit" },
      { label: "编辑邮箱", href: "/contact" },
      { label: "投稿常见问题", href: "/faq" },
    ],
  },
  {
    title: "内容板块",
    links: [
      { label: "爆料线索库", href: "/leads" },
      { label: "消费维权", href: "/leads?category=consumer" },
      { label: "职场内幕", href: "/leads?category=workplace" },
      { label: "民生身边事", href: "/leads?category=livelihood" },
    ],
  },
  {
    title: "关于直曝",
    links: [
      { label: "网站定位", href: "/about" },
      { label: "内容原则", href: "/about" },
      { label: "编辑流程", href: "/about" },
      { label: "联系我们", href: "/contact" },
    ],
  },
];